













































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import SelectStadium from '@/components/selectstadium.vue';

import MyForm from '@/mixins/form';

@Component({
  components: {
    SelectStadium,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() userId!: number;

  rechargeRules: any[] = [];

  async selectStadium(e: any) {
    // console.log(e);
    const res = await this.$store.dispatch('stadium/getvipsetting', {
      stadium_id: e,
    });
    if (res && res.Data && res.Data !== '{}') {
      if (res.Data.recharge_rules) {
        const rules1 = JSON.parse(res.Data.recharge_rules);

        this.rechargeRules = _.sortBy(rules1, (o: any) => Number(o.valid_sn));
      }
    }
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch('users/testbuy', {
              user_id: this.userId,
              ...fieldValues,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
